const callbacks = {
    afterSetup: () => { console.log("Callback setup não implementado.") },
    afterAuth: () => { console.log("Callback autenticação não implementado.") },
    afterPaymentsSuccess: () => { console.log("Callback sucesso do pagamento não implementado.") },
    afterPaymentsError: () => { console.log("Callback erro do pagamento não implementado.") },
    afterPaymentsCanceled: () => { console.log("Callback cancelamento do pagamento não implementado.") },
    afterRefundSuccess: () => { console.log("Callback sucesso do reembolso não implementado.") },
    afterRefundError: () => { console.log("Callback erro do reembolso não implementado.") },
    afterPaymentStatusSuccess: () => { console.log("Callback sucesso do status do pagamento não implementado.") },
    afterPaymentStatusError: () => { console.log("Callback erro do status do pagamento não implementado.") },
    afterLocationSuccess: () => { console.log("Callback sucesso do pedido de localização não implementado.") },
    afterLocationError: () => { console.log("Callback erro do pedido de localização não implementado.") },
    afterFinishScannerCodeReader: () => { console.log("Callback leitor de código de barras não implementado.") },
    afterRedirectFromScannerCodeReader: () => { console.log("Callback redirecionamento do leitor de código de barras não implementado.") },
    afterShareScreenDidFinishSuccess: () => { console.log("Callback sucesso do compartilhamento de tela não implementado.") },
    afterShareScreenDidFinishFail: () => { console.log("Callback erro do compartilhamento de tela não implementado.") },
    afterShareScreenDidCancel: () => { console.log("Callback do cancelamento do compartilhamento de tela não implementado.") }
}

const setCallback = (name, callback) => {
    if (callback) {
        callbacks[name] = callback;
    }
}

export { callbacks, setCallback };